const palette = {
  primary: {
    main: "#FEC210",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#005B4A ",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
